'use client'

import {useState} from "react";
import React from "react";
import Link from "next/link";

export default function StickyFooter() {
    const [visibleDefaultFooter, setVisibleDefaultFooter] = useState(false);
    const [visibleHeroCta, setVisibleHeroCta] = useState(true);
    const [pulse, setPulse] = useState(true)

    if (typeof window !== 'undefined') {
        const heroCta = document.querySelector('#hero-cta');

        document.addEventListener('scroll', () => {
            const {top, height, bottom} = heroCta?.getBoundingClientRect() || 0;
            console.log(top, height, bottom)
            setVisibleDefaultFooter(bottom < 0)

            setVisibleHeroCta(top + height > 350);
        })
    }

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setPulse(!pulse)
    //     }, 1000);
    //     return () => clearInterval(interval);
    // }, [pulse, setPulse]);

    return (
        <>
            {visibleDefaultFooter ?
                <div className="default-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 default-footer-label">
                                <h2>To get started, simply click here:</h2>
                            </div>
                            <div className="col-md-4 default-footer-label">
                                <div>
                                    <Link className="btn btn-default cta-btn" id="sticky-cta" href="/submit-extension" prefetch={false}>
                                        Submit IRS Extension
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className={`sticky-footer ${visibleHeroCta ? '' : 'is-sticky'}`}>
                    <div>
                        File your extension today!
                    </div>

                    <Link
                        className={`
                        btn btn-default cta-btn
                        ${pulse ? 'animate__animated animate__pulse' : ''}
                    `}
                        href="/submit-extension"
                        prefetch={false}
                        id="sticky-cta"
                    >
                        Get Started
                    </Link>
                </div>
            }

        </>
    )
}
